var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import objectArrayTrait, { MergeStrategy } from "../Decorators/objectArrayTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import ModelTraits from "../ModelTraits";
import LegendTraits from "./LegendTraits";
let LegendOwnerTraits = (_dec = objectArrayTrait({
  name: "Legend URLs",
  description: "The legends to display on the workbench.",
  type: LegendTraits,
  idProperty: "index",
  merge: MergeStrategy.None
}), _dec2 = primitiveTrait({
  type: "string",
  name: "Legend background color",
  description: "Apply background color to all legends. This can be useful if legends are transparent and clash with Terria colours"
}), _dec3 = primitiveTrait({
  type: "boolean",
  name: "Hide legend in workbench",
  description: "Whether the legend is hidden in the workbench for this catalog member."
}), _class = class LegendOwnerTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "legends", _descriptor, this);
    _initializerDefineProperty(this, "legendBackgroundColor", _descriptor2, this);
    _initializerDefineProperty(this, "hideLegendInWorkbench", _descriptor3, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "legends", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "legendBackgroundColor", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "hideLegendInWorkbench", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _class);
export { LegendOwnerTraits as default };